import { render, staticRenderFns } from "./back-overseasreturnorder.vue?vue&type=template&id=6b8b4e96&"
import script from "./back-overseasreturnorder.vue?vue&type=script&lang=ts&"
export * from "./back-overseasreturnorder.vue?vue&type=script&lang=ts&"
import style0 from "./back-overseasreturnorder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports